import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const INTERLINK_MAP = {
  home: [
    { label: 'Our Legacy', desc: 'The story behind a decade of manufacturing excellence', url: '/legacy' },
    { label: 'Pricing Guide', desc: 'Transparent factory-direct pricing for all categories', url: '/pricing-guide' },
    { label: 'Comparison Guide', desc: 'Modular vs traditional — an honest breakdown', url: '/comparison-guide' },
    { label: 'Delivered Workspaces', desc: 'Real projects from real offices across India', url: '/projects' },
  ],
  about: [
    { label: 'Our Legacy', desc: 'From EZFPL to MFS — a decade of evolution', url: '/legacy' },
    { label: 'All Products', desc: 'Browse our entire modular furniture collection', url: '/products' },
    { label: 'Delivered Workspaces', desc: 'See our work in action across 5,000+ offices', url: '/projects' },
    { label: 'Contact Us', desc: 'Talk to our workspace planning team', url: '/contact' },
  ],
  legacy: [
    { label: 'About MFS', desc: 'Our mission and what drives us', url: '/about' },
    { label: 'Browse Products', desc: 'See the furniture we manufacture', url: '/products' },
    { label: 'Pricing Guide', desc: 'Factory-direct pricing for every category', url: '/pricing-guide' },
    { label: 'Bulk Inquiry', desc: 'Get custom quotes for large orders', url: '/bulk-inquiry' },
  ],
  products: [
    { label: 'Pricing Guide', desc: 'Detailed pricing breakdown by category', url: '/pricing-guide' },
    { label: 'Comparison Guide', desc: 'How modular stacks up against alternatives', url: '/comparison-guide' },
    { label: 'Bulk Inquiry', desc: 'Need 10+ units? Get volume discounts', url: '/bulk-inquiry' },
    { label: 'Delivered Workspaces', desc: 'See these products installed in real offices', url: '/projects' },
  ],
  projects: [
    { label: 'Browse Products', desc: 'Shop the furniture from these projects', url: '/products' },
    { label: 'Pricing Guide', desc: 'See what these setups actually cost', url: '/pricing-guide' },
    { label: 'Bulk Inquiry', desc: 'Get a similar setup for your office', url: '/bulk-inquiry' },
    { label: 'Our Legacy', desc: 'The manufacturing story behind every project', url: '/legacy' },
  ],
  blog: [
    { label: 'All Products', desc: 'Browse our complete furniture collection', url: '/products' },
    { label: 'Pricing Guide', desc: 'Factory-direct pricing — no surprises', url: '/pricing-guide' },
    { label: 'Comparison Guide', desc: 'Modular vs traditional — all the facts', url: '/comparison-guide' },
    { label: 'Contact Us', desc: 'Have a question about something you read?', url: '/contact' },
  ],
  blogPost: [
    { label: 'Modular Workstations', desc: 'From ₹5,320 — factory direct', url: '/products?category=Modular+Office+Workstation' },
    { label: 'Privacy Booths', desc: 'Soundproof pods from ₹1,35,000', url: '/products?category=Privacy+Booths' },
    { label: 'Storage Solutions', desc: 'Cabinets & pedestals from ₹4,226', url: '/products?category=Storage+Cabinets' },
    { label: 'Pricing Guide', desc: 'Complete pricing for all categories', url: '/pricing-guide' },
    { label: 'Get Bulk Quote', desc: 'Volume discounts for 10+ units', url: '/bulk-inquiry' },
  ],
  contact: [
    { label: 'All Products', desc: 'Browse before you call', url: '/products' },
    { label: 'Pricing Guide', desc: 'Check pricing before requesting a quote', url: '/pricing-guide' },
    { label: 'Bulk Inquiry', desc: 'Structured form for large orders', url: '/bulk-inquiry' },
    { label: 'Our Legacy', desc: 'Learn about the team behind MFS', url: '/legacy' },
  ],
  cart: [
    { label: 'Browse More Products', desc: 'Add more to your order', url: '/products' },
    { label: 'Bulk Inquiry', desc: 'Ordering 10+ units? Get a better deal', url: '/bulk-inquiry' },
    { label: 'Pricing Guide', desc: 'Compare prices across categories', url: '/pricing-guide' },
  ],
  pricingGuide: [
    { label: 'Browse Products', desc: 'See the full collection with photos', url: '/products' },
    { label: 'Comparison Guide', desc: 'Modular vs traditional — decide with data', url: '/comparison-guide' },
    { label: 'Bulk Inquiry', desc: 'Get custom pricing for your order size', url: '/bulk-inquiry' },
    { label: 'Delivered Workspaces', desc: 'See real installations at these price points', url: '/projects' },
  ],
  comparisonGuide: [
    { label: 'Browse Products', desc: 'Ready to choose? See our collection', url: '/products' },
    { label: 'Pricing Guide', desc: 'Detailed pricing for every category', url: '/pricing-guide' },
    { label: 'Our Legacy', desc: 'The manufacturing philosophy behind MFS', url: '/legacy' },
    { label: 'Contact Us', desc: 'Still deciding? Talk to our team', url: '/contact' },
  ],
  bulkInquiry: [
    { label: 'Pricing Guide', desc: 'Check listed prices before requesting bulk rates', url: '/pricing-guide' },
    { label: 'Delivered Workspaces', desc: 'See past bulk installations', url: '/projects' },
    { label: 'Comparison Guide', desc: 'Why modular beats traditional for bulk', url: '/comparison-guide' },
    { label: 'Our Legacy', desc: '5,000+ offices furnished — the story', url: '/legacy' },
  ],
  locationBkcMumbai: [
    { label: 'Office Furniture Andheri–Powai', desc: 'Furniture for tech parks & BPOs nearby', url: '/office-furniture-andheri-powai' },
    { label: 'All Products', desc: 'Browse the full modular catalogue', url: '/products' },
    { label: 'Bulk Inquiry', desc: 'Get volume discounts for 10+ seats', url: '/bulk-inquiry' },
    { label: 'Pricing Guide', desc: 'Transparent factory-direct pricing', url: '/pricing-guide' },
  ],
  locationAndheriPowai: [
    { label: 'Office Furniture BKC Mumbai', desc: 'Premium furniture for BKC corporate towers', url: '/office-furniture-bkc-mumbai' },
    { label: 'Office Furniture Navi Mumbai', desc: 'For data centres & tech campuses', url: '/office-furniture-navi-mumbai' },
    { label: 'All Products', desc: 'Browse the full modular catalogue', url: '/products' },
    { label: 'Bulk Inquiry', desc: 'Get volume discounts for 10+ seats', url: '/bulk-inquiry' },
  ],
  locationNaviMumbai: [
    { label: 'Office Furniture Andheri–Powai', desc: 'Furniture for tech parks & BPOs', url: '/office-furniture-andheri-powai' },
    { label: 'Office Furniture Pune', desc: 'For Hinjewadi & Kharadi IT parks', url: '/office-furniture-pune' },
    { label: 'All Products', desc: 'Browse the full modular catalogue', url: '/products' },
    { label: 'Pricing Guide', desc: 'Transparent factory-direct pricing', url: '/pricing-guide' },
  ],
  locationPune: [
    { label: 'Office Furniture Navi Mumbai', desc: 'For data centres & tech corridor', url: '/office-furniture-navi-mumbai' },
    { label: 'Office Furniture Bengaluru', desc: 'For GCC campuses & tech capital', url: '/office-furniture-bengaluru' },
    { label: 'All Products', desc: 'Browse the full modular catalogue', url: '/products' },
    { label: 'Bulk Inquiry', desc: 'Volume discounts for IT park orders', url: '/bulk-inquiry' },
  ],
  locationBengaluru: [
    { label: 'Office Furniture Hyderabad', desc: 'For HITEC City & Financial District', url: '/office-furniture-hyderabad' },
    { label: 'Office Furniture Pune', desc: 'For Hinjewadi & Kharadi IT parks', url: '/office-furniture-pune' },
    { label: 'All Products', desc: 'Browse the full modular catalogue', url: '/products' },
    { label: 'Bulk Inquiry', desc: 'GCC & campus-scale bulk quotes', url: '/bulk-inquiry' },
  ],
  locationHyderabad: [
    { label: 'Office Furniture Bengaluru', desc: 'For tech campuses & GCC offices', url: '/office-furniture-bengaluru' },
    { label: 'Office Furniture Gurugram', desc: 'For MNC fit-outs in Delhi NCR', url: '/office-furniture-gurugram' },
    { label: 'All Products', desc: 'Browse the full modular catalogue', url: '/products' },
    { label: 'Pricing Guide', desc: 'Transparent factory-direct pricing', url: '/pricing-guide' },
  ],
  locationGurugram: [
    { label: 'Office Furniture Hyderabad', desc: 'For HITEC City & Financial District', url: '/office-furniture-hyderabad' },
    { label: 'Office Furniture Mumbai', desc: 'For India\'s commercial capital', url: '/office-furniture-mumbai' },
    { label: 'All Products', desc: 'Browse the full modular catalogue', url: '/products' },
    { label: 'Bulk Inquiry', desc: 'MNC-scale bulk quotes & fit-outs', url: '/bulk-inquiry' },
  ],
  locationMumbai: [
    { label: 'Office Furniture BKC', desc: 'Premium financial district towers', url: '/office-furniture-bkc-mumbai' },
    { label: 'Office Furniture Andheri–Powai', desc: 'Tech parks & BPO centres', url: '/office-furniture-andheri-powai' },
    { label: 'Office Furniture Thane', desc: 'Closest to our Bhiwandi factory', url: '/office-furniture-thane' },
    { label: 'All Products', desc: 'Browse the full modular catalogue', url: '/products' },
  ],
  locationThane: [
    { label: 'Office Furniture Mumbai', desc: 'India\'s commercial capital', url: '/office-furniture-mumbai' },
    { label: 'Office Furniture Navi Mumbai', desc: 'Data centres & tech corridor', url: '/office-furniture-navi-mumbai' },
    { label: 'All Products', desc: 'Browse the full modular catalogue', url: '/products' },
    { label: 'Bulk Inquiry', desc: 'Volume discounts for bulk orders', url: '/bulk-inquiry' },
  ],
  locationChennai: [
    { label: 'Office Furniture Bengaluru', desc: 'Tech capital & GCC campuses', url: '/office-furniture-bengaluru' },
    { label: 'Office Furniture Hyderabad', desc: 'HITEC City & Financial District', url: '/office-furniture-hyderabad' },
    { label: 'All Products', desc: 'Browse the full modular catalogue', url: '/products' },
    { label: 'Pricing Guide', desc: 'Transparent factory-direct pricing', url: '/pricing-guide' },
  ],
  locationAhmedabad: [
    { label: 'Office Furniture Mumbai', desc: 'India\'s commercial capital', url: '/office-furniture-mumbai' },
    { label: 'Office Furniture Pune', desc: 'Hinjewadi & Kharadi IT parks', url: '/office-furniture-pune' },
    { label: 'All Products', desc: 'Browse the full modular catalogue', url: '/products' },
    { label: 'Bulk Inquiry', desc: 'Volume discounts for Gujarat offices', url: '/bulk-inquiry' },
  ],
};

export function RelatedPages({ pageKey, className = '' }) {
  const links = INTERLINK_MAP[pageKey];
  if (!links || links.length === 0) return null;

  return (
    <section className={`border-t border-gray-100 pt-10 ${className}`} data-testid="related-pages">
      <h2 className="text-lg font-extrabold text-[#1a1a1a] mb-5 uppercase tracking-tight">
        Explore More
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {links.map((link, i) => (
          <Link
            key={i}
            to={link.url}
            className="group border border-gray-100 hover:border-[#c5a059] p-4 transition-all"
          >
            <p className="text-sm font-bold text-[#1a1a1a] group-hover:text-[#c5a059] transition-colors flex items-center gap-1">
              {link.label}
              <ArrowRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
            </p>
            <p className="text-xs text-gray-500 mt-1 leading-relaxed">{link.desc}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}

export { INTERLINK_MAP };
